/* Componentes de tela em HTML: estados de carga, cartões, tabelas e selos. */

import { isApi } from '../core/config';
import { esc } from '../core/formato';
import { ic } from './dom';

export const loading = (t = 'Carregando…') => `<div class="loading">${t}</div>`;

export const vazio = (t = 'Nenhuma emissão encontrada para os filtros selecionados.') => `<div class="loading">${t}</div>`;

export function erroBox(e: unknown): string {
  const msg = (e as Error)?.message || String(e);
  return `<div class="callout warn">${ic('i-alert')}<div><b>Não foi possível carregar.</b><br>${esc(msg)}
    ${isApi() ? `<br><a href="#/config" style="font-weight:700;text-decoration:underline">Revisar conexão com a API</a>` : ''}</div></div>`;
}

export function kpi(titulo: string, valor: string, unidade: string, nota?: string): string {
  return `<div class="card">
    <div class="kpi-head"><div class="kpi-title">${titulo}</div></div>
    <div class="kpi-val"><b class="num">${valor}</b>${unidade ? `<span>${unidade}</span>` : ''}</div>
    ${nota ? `<div class="kpi-note">${nota}</div>` : ''}
  </div>`;
}

export const tableFoot = (n: number) =>
  `<div class="table-foot"><span class="num">${n ? `1–${n} de ${n}` : '0 registros'}</span></div>`;

export function emptyTable(colunas: string[], msg = 'Nenhum registro ainda'): string {
  return `<div class="table-wrap"><table class="table"><thead><tr>${colunas.map((c) => `<th>${c}</th>`).join('')}</tr></thead>
  <tbody><tr class="empty-row"><td colspan="${colunas.length}">${msg}</td></tr></tbody></table></div>`;
}

export interface Coluna<T> {
  /** Título da coluna. */
  l: string;
  /** Alinhada à direita (números). */
  r?: boolean;
  /** HTML da célula. */
  f: (linha: T) => string;
}

export function tabela<T>(colunas: Coluna<T>[], linhas: T[], rodape?: (string | number)[] | null): string {
  if (!linhas.length) return emptyTable(colunas.map((c) => c.l), 'Nenhuma emissão encontrada para os filtros selecionados.');
  return `<div class="table-wrap"><table class="table">
    <thead><tr>${colunas.map((c) => `<th class="${c.r ? 'r' : ''}">${c.l}</th>`).join('')}</tr></thead>
    <tbody>${linhas.map((l) => `<tr>${colunas.map((c) => `<td class="${c.r ? 'r num' : ''}">${c.f(l)}</td>`).join('')}</tr>`).join('')}</tbody>
    ${rodape ? `<tfoot><tr>${rodape.map((v, i) => `<td class="${colunas[i].r ? 'r num' : ''}">${v}</td>`).join('')}</tr></tfoot>` : ''}
  </table></div>`;
}

export const escLabel = (e: unknown) => (e ? `Escopo ${e}` : 'Sem escopo');

const ESCOPO_FUNDO = [0, 1, 2, 3].map((i) => `var(--e${i}-bg)`);
const ESCOPO_TEXTO = [0, 1, 2, 3].map((i) => `var(--e${i}-fg)`);

export const pillEscopo = (e: unknown) => {
  const i = Number(e) || 0;
  return `<span class="pill" style="border-color:transparent;background:${ESCOPO_FUNDO[i]};color:${ESCOPO_TEXTO[i]}">${escLabel(e)}</span>`;
};

export const rotuloCategoria = (c: unknown) => String(c || 'Sem categoria');

export const legendaEscopos = (estilo = '') => `<div class="legend"${estilo ? ` style="${estilo}"` : ''}>
  <span><i style="background:var(--esc1)"></i>Escopo 1</span>
  <span><i style="background:var(--esc2)"></i>Escopo 2</span>
  <span><i style="background:var(--esc3)"></i>Escopo 3</span></div>`;
